import HttpService from "../../hooks/Https-services";
import { APIRoutes } from "../../utils/constants";

export default (() => {
  const api = HttpService;
  return {
    getAllCountries: () => {
      console.log("getAllCountries");
      return api.get(APIRoutes.GetCountryList);
    },
    getAllRules: () => {
      console.log("getAllRules");
      return api.get(`${APIRoutes.GetRuleList}?limit=25`);
    },
    getRuleById: (ruleId: string) => {
      console.log("getRuleById", ruleId);
      return api.get(APIRoutes.GetRuleById.replace(":id", ruleId));
    },
    detectLocation: () => {
      console.log("detectLocation");
      return api.get(APIRoutes.GetGeoIp);
    },
  };
})();
